

















































































































































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import DocumentIcon from '@/components/documents/DocumentIcon.vue';

@Component({
  components: {
    AccountIcon,
    DocumentIcon,
    CommonButton,
  },
})
export default class SettingDirectoryModal extends Vue {
  @Prop(Boolean) public isOpenSettingDirectoryModal!: boolean;
  private edit: boolean = false;
  private userIcon: string = require('../../assets/test.jpeg');
  private CommonButtonColorEdit: string = '#4384f3';
  private CommonButtonColorSave: string = '#4384f3';
  private CommonButtonColorBrowsing: string = '#4384f3';
  private documentAvatarSize: number = 50;
  private documentAvatarColor: string = '#4384f3';
  private documentIconSize: number = 27;
  private documentIconColor: string = 'white';
  private documentAvatarSizeEdit: number = 50;
  private documentAvatarColorEdit: string = '#4384f3';
  private documentIconSizeEdit: number = 27;
  private documentIconColorEdit: string = 'white';
  @Emit('closeSettingDirectoryModal')
  private closeSettingDirectoryModal() {
    this.isOpenSettingDirectoryModal = false;
  }
}
